import React from 'react';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Core components
import MenuButton from 'components/core/MenuButton';
import Tooltip from 'components/core/Tooltip';
// Color
import { statusPalette } from 'components/core/colors';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mDoor from 'models/door';
// Custom
import { doorDataShape, menuItemsShape, permissionsShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import AppIcon from 'components/icons/AppIcon';

const DoorWarningScenario = ({ door }) => {
  if (!door.scenario) {
    return (
      <Tooltip content={<LocalizedMessage id="tooltip.doorNoScenario" />}>
        <AppIcon id="warningAlt" color={statusPalette.warning} />
      </Tooltip>
    );
  }
  return null;
};

DoorWarningScenario.propTypes = {
  door: doorDataShape.isRequired,
};

const DoorItem = ({
  door, toggle, menuItems, permissions,
}) => {
  const intl = useIntl();

  return (
    <InformationItem
      label={intl.formatMessage({ id: `door.type.${door.type}` })}
      value={door.name}
      icon={mDoor.usage(door).icon}
      withAvatar
      toggle={toggle}
      rightIcon={<DoorWarningScenario door={door} />}
      rightButton={!_isEmpty(menuItems) ? <OnlyWith permissions={permissions}><MenuButton obj={door} items={menuItems} /></OnlyWith> : null}
    />
  );
};

DoorItem.propTypes = {
  door: doorDataShape.isRequired,
  toggle: PropTypes.shape({
    toggled: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
  }),
  menuItems: menuItemsShape,
  permissions: permissionsShape,
};

DoorItem.defaultProps = {
  toggle: null,
  menuItems: null,
  permissions: null,
};

module.exports = DoorItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/DoorItem.js